import { Box, Flex, SimpleGrid, Text } from "@chakra-ui/react";
import {
  BLUEMONEDD,
  ORANGEMONEDD,
  WHITE,
  YELLOWMONEDD,
} from "../../../constants/colors";
import { JWTToken } from "../../vendas/listaDeVendas/components/SalesList";
import jwt_decode from "jwt-decode";
import ExtratoApi from "../../../services/ExtratoAPI";
import moment from "moment";
import { useEffect, useState } from "react";
import { dateForAPI } from "../../../constants/dataFormat";
import { useRecoilState } from "recoil";
import { LoggedUser } from "../../../atoms/userLogged";
import { selectedClientHeader } from "../../../atoms/selectedClientHeader";

export default function CardSaldo() {
  const yellow = "#FBC500";

  const todayMorning = moment()
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss.SSS");
  const todayNight = moment()
    .endOf("day")
    // .add("day", 2)
    .format("YYYY-MM-DDTHH:mm:ss.SSS");

  const user = useRecoilState(LoggedUser)[0];
  const selectedId = useRecoilState(selectedClientHeader)[0];

  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const id = user.idLoginTipo === 4 ? Number(jwtToken.idCliente) : Number(selectedId);
  const [saldoCliente, setSaldoCliente] = useState(0);
  const [saldoFuturo, setSaldoFuturo] = useState(0);
  const tomorrow = moment()
    .startOf("day")
    .add(1, "day")
    .format("YYYY-MM-DDTHH:mm:ss.SSS");
  const future = moment("2077-12-31").format(dateForAPI);

  async function getSaldo() {
    try {
      const response = await ExtratoApi.getSaldo(
        1,
        100,
        todayMorning,
        todayNight,
        id
      );
      
      let aux = 0;
      for(let i = 0; i < response.data.length; i++){
        aux += response.data[i]?.saldoAnterior + response.data[i]?.saldoPeriodo
      }
      // setSaldoClienta[0]
      //     ? responte(
      //   response.dase.data[0]?.saldoAnterior + response.data[0]?.saldoPeriodo
      //     : 0
      // );
      setSaldoCliente(aux);
      const response2 = await ExtratoApi.getSaldo(1, 100, tomorrow, future, id);
      
      let aux2 = 0;
      for(let i = 0; i < response.data.length; i++){
        aux2 += response2.data[i]?.saldoPeriodo
      }
      // setSaldoFuturo(response2.data[0].saldoPeriodo);
      setSaldoFuturo(aux2);
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    getSaldo();
  }, [id]);

  return (
    <Flex
      w={"80%"}
      // bgColor={"#1C3E92"}
      h={"100%"}
      flexDir="column"
      justifyContent={"space-evenly"}
      alignItems={"space-evenly"}
    >
      <SimpleGrid columns={2} p={4} spacingX={10}>
        <Flex w={"100%"} h={"100%"} flexDir="column">
          <Text color={WHITE} fontSize={"1.3vw"} fontWeight={"bold"}>
            SALDO ATUAL
          </Text>
          <Text color={yellow} fontWeight="bold" fontSize={"1.8vw"}>
            {saldoCliente
              ? saldoCliente.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })
              : "R$ 0,00"}
          </Text>
        </Flex>
        <Flex w={"100%"} h={"100%"} flexDir="column">
          <Text color={WHITE} fontSize={"1.3vw"} fontWeight={"bold"}>
            A RECEBER
          </Text>
          <Text color={yellow} fontWeight="bold" fontSize={"1.8vw"}>
            {saldoFuturo
              ? saldoFuturo.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })
              : "R$ 0,00"}
          </Text>
        </Flex>
      </SimpleGrid>
    </Flex>
  );
}
